import * as React from 'react';
import { cn } from '../lib/utils.js';

export interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  required?: boolean;
}

const Label = React.forwardRef<HTMLLabelElement, LabelProps>(
  ({ className, required, children, ...props }, ref) => {
    return (
      <label
        ref={ref}
        className={cn(
          'text-[12px] font-medium text-muted-foreground leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
          className,
        )}
        {...props}
      >
        {children}
        {required ? <span className="text-destructive ml-0.5">*</span> : null}
      </label>
    );
  },
);
Label.displayName = 'Label';

export { Label };
